module.exports = __webpack_public_path__ + "img/a11y-color-naming-1_jp.8fae92f.jpg";